import { defineMessages } from 'react-intl';

export default defineMessages({
  addCommentButton: {
    id: 'frontbucket.editor.multicomment.addComment',
    description: 'Button label to add comment to in progress review',
    defaultMessage: 'Add comment',
  },
  addCommentNowButton: {
    id: 'frontbucket.editor.multicomment.addCommentNow',
    description: 'Button label to add comment immediately to PR',
    defaultMessage: 'Add comment now',
  },
  startReviewButton: {
    id: 'frontbucket.editor.multicomment.startReview',
    description: 'Button label to start review',
    defaultMessage: 'Start review',
  },
  cancelButton: {
    id: 'frontbucket.editor.multicomment.cancel',
    description: 'Button label to cancel adding comment',
    defaultMessage: 'Cancel',
  },
});
